import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Login from './Login';
import Register from './Register';
import Admin from './admin/Admin';
import CharacterCreator from './CharacterCreator';
import CharacterSheet from './character_sheet/CharacterSheet';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'katex/dist/katex.min.css';

import useTooltipObserver from '../hooks/useTooltipObserver';
import { useUserInfo } from '../hooks/useUserInfo';
import { useAuth } from '../hooks/useAuth';

function App() {
    const { isLoggedIn } = useAuth();
    const { userInfo } = useUserInfo();

    useTooltipObserver();

    return (
        <Router>
            <Routes>
                {isLoggedIn ? (
                    <>
                        <Route path='/' element={<CharacterCreator />} />
                        <Route path='/characters/:characterId' element={<CharacterSheet />} />
                    </>
                ) : (
                    <Route path='/' element={<Login />} />
                )}
                <Route path='/login' element={<Login />} />
                <Route path='/register' element={<Register />} />
                {userInfo?.isAdmin && <Route path='/admin' element={<Admin />} />}
            </Routes>
        </Router>
    );
}

export default App;
